export function isOutboundLink(href) {
  try {
    const targetUrl = new URL(href, window.location.href);
    const normalizedTargetHostname = targetUrl.hostname.replace(/^www\./i, '');
    const normalizedCurrentHostname = window.location.hostname.replace(/^www\./i, '');
    return normalizedTargetHostname !== normalizedCurrentHostname;
  } catch {
    return false;
  }
}